const EXAMS_ACCREDITED_NETWORK_DEFAULT_DISTANCE = '25';

export {EXAMS_ACCREDITED_NETWORK_DEFAULT_DISTANCE};
